<template>
	<section class="section-container" v-if="!is_supplier">
		<div class="content-wrapper">
			<div class="content-heading" v-if="this.editMode">
				Halda
			</div>
			<div class="content-heading" v-else>
				<div class="row" style="width:100%;">
					<div class="col-md-6 text-left pull-left">
						<div v-if="!editMode">{{$t('productcat.new')}}</div>
						<div v-if="editMode">{{$t('productcat.edit-title-head')}}</div>
					</div>
					<div class="col-md-6 text-right pull-right">
					</div>
				</div>
			</div>
			<!--  Content -->
			<div class="row">
				<div class="col-xl-4">
					<div class="card card-default">
						<div class="card-body">
							<div class="form-group">
								<label>{{$t('productcat.name')}} *</label>
								<input class="form-control" v-model="form.categoryName" type="text"
									   :placeholder="$t('productcat.insert-name')">
							</div>
							<div class="form-group">
								<label>{{$t('productcat.code')}}</label>
								<input class="form-control" v-model="form.categoryCode" type="text"
									   :placeholder="$t('productcat.insert-code')">
							</div>
							<div class="form-group">
								<label>{{ $t('make.groups') }}*</label>
								<multiselect
										v-model="form.group"
										:tag-placeholder="$t('productcat.group-add-new')"
										:placeholder="$t('productcat.group-add-new')"
										label="name"
										track-by="name"
										:options="groups"
										:multiple="true"
										:taggable="true">
									<template slot="noOptions">{{ $t('global.no-options') }}</template>
								</multiselect>
								<ul class="parsley-errors-list filled" v-if="errors.groups">
									<li class="parsley-required">{{$t('productcat.group')}}</li>
								</ul>
							</div>
							<div class="row pb-3">
								<div class="col-md-6">
									<div class="checkbox c-checkbox">
										<label>
											<input type="checkbox" v-model="form.categoryActive" checked="true">
											<span class="fa fa-check"></span>{{$t('productcat.active')}}</label>
									</div>
								</div>
								<div class="col-md-6" v-if="!editMode">
									<div class="checkbox c-checkbox">
										<label>
											<input type="checkbox">
											<span class="fa fa-check"></span>{{$t('productcat.add-next')}}</label>
									</div>
								</div>
							</div>
							<div class="text-right">
								<router-link :to="{ name: 'admin_product_cat' }" class="btn btn-sm btn-secondary wd-xs">
									{{$t('productcat.cancel')}}
								</router-link>
								<a href="#" @click="validateAction()" class="btn btn-sm btn-success wd-xs"
								   type="submit">{{$t('productcat.save')}}</a>
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>

		<modal v-if="showModal">
			<h4 class="modal-title" slot="header-text">{{ $t('modal.header.text') }}</h4>
			<div class="modal-body" slot="modal-body">
				<p class="text-bold">{{ $t('modal.section1.header') }}</p>
				<p>{{ modal_data_1 }}</p>
				<p class="text-bold">{{ $t('modal.section2.header') }}</p>
				<p>{{ modal_data_2}}</p>
			</div>
			<div slot="modal_buttons">
				<button class="btn btn-secondary" type="button" @click="close_modal()">{{ $t('modal.close') }}</button>
			</div>
		</modal>

	</section>
</template>

<script>
	import api from '@/api'
	import message from '@/message'
	import {Datetime} from 'vue-datetime'
	import Pagination from '@/components/Pagination.vue'
	import Search from '@/components/Search.vue'
	import {parseApiError} from '@/utils'
	import Modal from '@/components/Modal.vue'
	import Multiselect from 'vue-multiselect'

	const getData = (id, route, next) => {
		const search = route.query.search
		const ordering = route.query.ordering || 'pk'
		const page = parseInt(route.query.page) || 1
		const start = route.query.start
		const finish = route.query.finish
		const warehouse = route.query.warehouse || null
		const additional = route.query.additional || ''
		const catId = route.params.cat_id || null
		const group = route.query.group || null
		id = catId;

		if (catId > 0) {
			Promise.all([
				api.get(`/categories/${id}/`),
				api.get('/groups/?page_size=100')
			])
				.then(([category, groups]) => {
					let id = category.data.id;
					let name = category.data.name;
					let active = category.data.is_active;
					let catGroup = [];
					let groupsList = [];
					let groupsRegister = [];
					groups.data.results.forEach(g => {
						groupsList.push({
							'id': g.id,
							'name': g.name,
						})
						groupsRegister[g.id] = g.name;
					})

					category.data.groups.forEach(g => {
						catGroup.push({
								id:g,
								name:groupsRegister[g]
						});
					})

					next({
						form: {
							categoryId: id,
							categoryName: name,
							categoryCode: null,
							categoryActive: active,
							group:catGroup
						},
						groups:groupsList
					})
				})
		} else {
			Promise.all([
				api.get('/categories/'),
				api.get('/groups/?page_size=100')
			])
				.then(([cat, groups]) => {
					let groupsList = [];
					groups.data.results.forEach(g => {
						groupsList.push({
							'id': g.id,
							'name': g.name,
						})
					})
					next({
						form: {
							categoryId: 0,
							categoryName: null,
							categoryCode: null,
							categoryActive: true
						},
						groups: groupsList,
					})
				})
		}
	}

	export default {
		components: {
			datetime: Datetime,
			pagination: Pagination,
			search: Search,
			modal: Modal,
			Multiselect,
		},
		watch:{
			$route(to, from) {
				// react to route changes...
			}
		},
		data() {
			return {
				tender: {
					id: null,
					start: null,
					finish: null,
					additional_info: '',
					warehouse: null
				},
				form: {
					categoryId: 0,
					categoryName: null,
					categoryCode: null,
					categoryActive: true,
					group:[],
				},
				details: [],
				warehouses: [],
				groups: [],
				chosen: [],
				search: null,
				user_warehouse: null,
				ordering: null,
				count: null,
				errors: {},
				page: null,
				pages: null,
				showModal: false,
				modal_data_1: null,
				modal_data_2: null,
				warehouse_changed: false,
				editMode: false,
			}
		},
		mounted() {
			this.$parent.menu = 'productcatedit'
			this.$parent.submenu = ''
			this.$i18n.locale = this.$store.getters.language

			if (this.$route.params.cat_id > 0) {
				this.editMode = true;
			}
		},
		computed: {
			nestableItems: {
				get() {
					return this.$store.state.nestableItems;
				},
				set(value) {
					this.$store.dispatch('updateElements', value);
				}
			},
			is_supplier() {
				return this.$store.getters.user_group === 'Supplier'
			},
		},
		methods: {
			validateAction() {
				// Used to save the form or update edited data
				if (!this.editMode) {
					if (this.form.categoryName != null) {
						let groupsPush = [];
						this.form.group.forEach(fG => {
							groupsPush.push(fG.id);
						})
						api.post('/categories/', {
							name: this.form.categoryName,
							groups: groupsPush,
							order: 0,
							parent: 0,
							is_active: this.form.categoryActive,
							is_deleted: false
						});
						this.form.categoryName = null;
						this.form.categoryCode = null;
						message.success(this.$i18n.t('productcat.add_success'));
					} else {
						message.error(this.$i18n.t('productcat.add_failed'));
					}
				} else {
					if (this.form.categoryName != null) {
						let groupsPush = [];
						this.form.group.forEach(fG => {
							groupsPush.push(fG.id);
						})
						api.patch('/categories/' + this.form.categoryId + '/', {
							name: this.form.categoryName,
							groups: groupsPush,
							order: 0,
							parent: 0,
							is_active: this.form.categoryActive,
							is_deleted: false
						});
						message.success(this.$i18n.t('productcat.update_success'));
					} else {
						message.error(this.$i18n.t('productcat.add_failed'));
					}
				}

			},
			close_modal() {
				this.showModal = false
			},
			open_modal(data1, data2) {
				this.showModal = true
				this.modal_data_1 = data1
				this.modal_data_2 = data2
			},
			make_search() {
				this.$router.push({
					query: {
						search: this.search,
						ordering: this.ordering,
						page: 1,
						start: this.tender.start,
						finish: this.tender.finish,
						warehouse: this.tender.warehouse,
						group: this.tender.group,
						additional: this.tender.additional_info,
						tender_id: this.tender.id
					}
				})
			},
		},
		beforeRouteEnter(to, from, next) {
			getData(to.params.id, to, data => {
				next(vm => {
					Object.assign(vm.$data, data)
				})
			})
		},
		beforeRouteUpdate(to, from, next) {
			getData(to.params.id, to, data => {
				Object.assign(this.$data, data)
				next()
			})
		}
	}
</script>



// WEBPACK FOOTER //
// src/views/ProductCategoryEdit.vue